import { Component, Input, OnInit } from '@angular/core';

import { ApContentModule, ApContentService } from '@ap/content';
import { Betaaltransactie, BetaaltransactieStatus } from '@ap/interface-apic-betaalverzoek';
import { ApAnimationComponent, AvailableAnimations } from '@ap/animation';
import { ApErrorModule } from '@ap/error';

import { BetaalverzoekService } from '../../betaalverzoek.service';
import { BetaalverzoekErrorType } from '../../betaalverzoek.model';
import { BetaalverzoekNavigation } from '../../betaalverzoek.navigation';

import content from './transaction-result.content.json';

/**
 * @ngdoc component
 * @name ResultComponent
 *
 * @description
 * Component that provides functionality to display a successful or open transaction result
 */
@Component({
    selector: 'transaction-result',
    templateUrl: './transaction-result.component.html',
    imports: [ApErrorModule, ApContentModule, ApAnimationComponent]
})
export class TransactionResultComponent implements OnInit {
    private static readonly TIMEOUT_IN_SECONDS = 600;
    private static readonly SUCCESSFUL_ANIMATION = AvailableAnimations.PAYMENTREQUESTCOMPLETED;
    private static readonly WAITING_ANIMATION = AvailableAnimations.TRANSFERPROGRESS;

    @Input()
    public transactionStatus: BetaaltransactieStatus;

    public resultTitle: string;
    public resultMessage: string;
    public resultAnimation: AvailableAnimations;
    private transactieId;
    private toegangscode;
    private secondsCount = 0;

    public constructor(
        private readonly betaalverzoekNavigation: BetaalverzoekNavigation,
        private readonly betaalverzoekService: BetaalverzoekService,
        private readonly contentService: ApContentService
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.setTransactionResultContent(this.transactionStatus);
        this.setResultAnimation(this.transactionStatus);
        this.toegangscode = this.betaalverzoekService.getToegangscode();
        this.transactieId = this.betaalverzoekService.getTransactieId();
        if (this.transactionStatus === BetaaltransactieStatus.OPEN) {
            this.pollTransactieStatus();
        }
    }

    private setResultAnimation(status: string): void {
        this.resultAnimation =
            status === BetaaltransactieStatus.SUCCESS
                ? TransactionResultComponent.SUCCESSFUL_ANIMATION
                : TransactionResultComponent.WAITING_ANIMATION;
    }

    private setTransactionResultContent(status: string): void {
        this.resultTitle = this.contentService.get(`transaction-result-page.transaction.result.${status}.title`);
        this.resultMessage = this.contentService.get(`transaction-result-page.transaction.result.${status}.message`);
    }

    private pollTransactieStatus() {
        const interval = setInterval(() => {
            this.secondsCount += 5;
            this.betaalverzoekService.getBetaaltransactie(this.transactieId, this.toegangscode).subscribe({
                next: (betaaltransactie: Betaaltransactie) => {
                    if (betaaltransactie.status === BetaaltransactieStatus.SUCCESS) {
                        this.setResultAnimation(BetaaltransactieStatus.SUCCESS);
                        this.setTransactionResultContent(BetaaltransactieStatus.SUCCESS);
                        clearInterval(interval);
                    } else {
                        this.betaalverzoekService.navigateToErrorPageOnInvalidStatus(betaaltransactie.status);
                    }
                },
                error: () => {
                    this.betaalverzoekNavigation.toErrorPage(
                        BetaalverzoekService.generateErrorData(BetaalverzoekErrorType.TRANSACTION_REQUEST_SERVICE_UNAVAILABLE, false)
                    );
                }
            });

            if (this.secondsCount >= TransactionResultComponent.TIMEOUT_IN_SECONDS) {
                clearInterval(interval);
                this.betaalverzoekNavigation.toErrorPage(
                    BetaalverzoekService.generateErrorData(BetaalverzoekErrorType.APPLICATION_GENERIC_ERROR, false)
                );
            }
        }, 5000); //5 seconds
    }
}
